import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AlarmManagementModel } from '@models/alarm-management.model';
import { AuthSrcDirective } from '../../../shared/directives/auth-src.directive';

@Component({
  selector: 'app-image-preview-dialog',
  standalone: true,
  imports: [NgIf, MatDialogModule, MatIconModule, AuthSrcDirective],
  templateUrl: './image-preview-dialog.component.html',
  styleUrls: ['./image-preview-dialog.component.scss'],
})
export class ImagePreviewDialogComponent {
  public loadFailed: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlarmManagementModel.ImagePreviewDialogData,
  ) {}

  public close(): void {
    this.dialogRef.close();
  }

  public onError(): void {
    this.loadFailed = true;
  }
}
